import React from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import WelcomeSection from "@/pages/teacher/dashboard/_section/WelcomeSection";
import SummaryCards from "@/pages/teacher/dashboard/_section/SummaryCards";
import ClassesSection from "@/pages/teacher/dashboard/_section/ClassesSection";
import AssignmentsSection from "@/pages/teacher/dashboard/_section/AssignmentsSection";
import PerformanceChart from "@/pages/teacher/dashboard/_section/PerformanceChart";
import EarningsSection from "@/pages/teacher/dashboard/_section/EarningsSection";
import RenderIf from "@/components/render-if";
import {useApiReadTeacherDashboard} from "@/api/dashboard";
import {Card} from "antd";
import TextToHtml from "@/components/text-to-html";
import RenderLoading from "@/components/render-if-loading";
import TodayClass from "@/pages/teacher/dashboard/_section/TodayClass";


function TeacherDashboardPage() {

    const {data: teacherDashboard, isPending} = useApiReadTeacherDashboard()

    return (
        <TeacherLayout pageTitle={'بخش اساتید'}>
            <WelcomeSection/>

            <RenderLoading loading={isPending} skeleton={true}>
                <SummaryCards teacherDashboard={teacherDashboard}/>
            </RenderLoading>

            <div className="mt-6">
                <RenderLoading loading={isPending} skeleton={true}>
                    <TodayClass teacherDashboard={teacherDashboard}/>
                </RenderLoading>
            </div>

            <RenderIf condition={false}>


                <div className="mt-6">
                    <ClassesSection/>
                </div>
                <div className="mt-6">
                    <AssignmentsSection/>
                </div>
                <div className="mt-6">
                    <PerformanceChart/>
                </div>

                <div className="mt-6">
                    <EarningsSection/>
                </div>
            </RenderIf>


            <RenderIf condition={teacherDashboard?.data?.data?.billboard}>
                <Card title="تابلو اعلانات" className={'rounded-2xl mt-4'}>
                    <TextToHtml>{teacherDashboard?.data?.data?.billboard}</TextToHtml>
                </Card>
            </RenderIf>

        </TeacherLayout>
    );
}

export default TeacherDashboardPage;